var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useCallback, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useUpdateUserStatusMutation } from '../../../../application/features/users/user-api';
import useTranslate from '../../../../localization/helpers';
var DeActivateUserDialog = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, user = _a.user;
    var _b = useTranslate(), translate = _b.translate, tWithFunction = _b.tWithFunction, tWithField = _b.tWithField;
    var _c = __read(useUpdateUserStatusMutation(), 2), updateUserStatus = _c[0], _d = _c[1], updateUserStatusLoading = _d.isLoading, updateUserStatusSuccess = _d.isSuccess;
    var handleSubmit = useForm({ reValidateMode: 'onChange' }).handleSubmit;
    var successMessage = useCallback(function () {
        enqueueSnackbar(tWithField('toolTips.deactivateSuccess', 'common.user'), {
            autoHideDuration: 3000,
            variant: 'success',
            anchorOrigin: { horizontal: 'right', vertical: 'top' }
        });
        onClose();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onClose]);
    useEffect(function () {
        if (updateUserStatusSuccess)
            successMessage();
    }, [successMessage, updateUserStatusSuccess]);
    var onSubmit = function (request) {
        updateUserStatus(__assign(__assign({}, request), { isActive: false, userId: user.id }));
    };
    return (_jsxs(Dialog, { open: isOpen, children: [_jsx(DialogTitle, { id: 'confirm-dialog-title', children: tWithFunction('actions.deactivateFunction', 'common.user') }), _jsx(DialogContent, { children: _jsx(DialogContentText, { id: 'confirm-dialog-description', children: tWithFunction('users.statusConfirmText', 'common.deactivate') }) }), _jsxs(DialogActions, { children: [_jsx(Button, { disabled: updateUserStatusLoading, variant: 'outlined', color: 'inherit', onClick: onClose, children: translate('actions.cancel') }), _jsx(Button, { disabled: updateUserStatusLoading, onClick: handleSubmit(onSubmit), variant: 'contained', color: 'warning', children: translate('actions.confirm') })] })] }));
};
export default DeActivateUserDialog;
